import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { IntroBreaker } from './components/IntroBreaker';
import { ImageBreaker } from './components/ImageBreaker';
import { LocationSection } from './components/LocationSection';
import { StatsSection } from './components/StatsSection';
import { FloorsSection } from './components/FloorsSection';
import { Slideshow } from './components/Slideshow';
import { FeatureGallery } from './components/FeatureGallery';
import { ContactSection } from './components/ContactSection';
import { CustomCursor } from './components/CustomCursor';
export function App() {
  useEffect(() => {
    document.title = 'Jrp Homes • Campanilla, Ayala Westgrove Heights';
  }, []);
  return <main id="top" className="relative w-full min-h-screen overflow-x-hidden bg-bg-warm text-text-primary" data-id="element-0" data-mp="28ufpyg1ohml6">
      <CustomCursor data-id="element-1" data-mp="23w4fq47h1a2f" />
      <Navbar data-id="element-2" data-mp="23ujjma5idj2g" />
      <HeroSection data-id="element-3" data-mp="23v2rey1g2r2r" />
      <IntroBreaker data-id="element-4" data-mp="23ti864kkyuk7" />
      <ImageBreaker data-id="element-5" data-mp="3ik7eyd5x05p2" />
      <LocationSection data-id="element-6" data-mp="3ikqwvtvkeu33" />
      <StatsSection data-id="element-7" data-mp="3ijfv1zlojwem" />
      <FloorsSection data-id="element-8" data-mp="3ihv1ac76whht" />
      <FeatureGallery data-id="element-9" data-mp="3mlawr57iwbsx" />
      <Slideshow data-id="element-10" data-mp="3mkrchhuehbbq" />
      <ImageBreaker src="https://cdn.magicpatterns.com/uploads/wiQfCXngrNLkRFoePdCmfM/WhatsApp_Image_2026-10-03_at_16.17.39_(1).jpg" alt="Upper-level living space with timber spiral staircase and floor-to-ceiling garden views" data-id="element-11" data-mp="3mk84asujy1aw" />
      <ContactSection data-id="element-12" data-mp="2zl3cxocsjc6w" />

      <footer className="py-8 text-center border-t border-black/5 relative z-10 bg-bg-warm" data-id="element-13" data-mp="2zlv84y2h77wn">
        <p className="text-xs text-text-muted font-light tracking-wide" data-id="element-14" data-mp="33m5e4aq9pybi">
          © 2026 JRP Homes. All rights reserved.
        </p>
      </footer>
    </main>;
}